/**
 * 防音個室ブースの時刻計算を行うhook
 */
export const usePrivateRoomTimeCalculation = () => {
  /**
   * 開始時刻と利用時間から終了時刻を計算する
   * @param startTime - 開始時刻（HH:mm形式）
   * @param durationMinutes - 利用時間（分）
   * @returns 終了時刻（HH:mm形式）
   * @example
   * calculateEndTime("10:30", 45) // "11:15"
   */
  const calculateEndTime = (
    startTime: `${string}:${string}`,
    durationMinutes: number,
  ): `${string}:${string}` => {
    const [hours, minutes] = startTime.split(':').map(Number);
    const startTotalMinutes = hours * 60 + minutes;
    const endTotalMinutes = startTotalMinutes + durationMinutes;

    const endHours = Math.floor(endTotalMinutes / 60) % 24;
    const endMinutes = endTotalMinutes % 60;

    return `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}` as `${string}:${string}`;
  };

  return {
    calculateEndTime,
  };
};
